<template>
  <v-list>
    <v-data-iterator :items="list" :options="options" :server-items-length="count">
      <template v-slot:default="{ items }">
        <v-list-item v-for="item in items" :key="item._id" @click="$emit('select', item)">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-data-iterator>
  </v-list>
</template>
<script>
export default {
  data: () => ({
    list: [],
    count: 0,
    filter: '',
    options: {
      page: 1,
      itemsPerPage: 10
    }
  }),
  watch: {
    filter () {
      this.load()
    },
    options: {
      handler () {
        this.load()
      },
      deep: true
    }
  },
  methods: {
    load () {
      let query = {
        $limit: this.itemsPerPage,
        $skip: (this.page - 1) * this.itemsPerPage,
        $sort: { title: 1 }
      }
      if (this.filter !== '') query.title = { $regex: new RegExp(this.filter, 'ig') }
      this.$feathers.service('system/email-template').find({ query })
        .then(({ data, total }) => {
          this.count = total
          this.list = data
        })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
